import { User } from '@xpo-ltl/sdk-common';

type UserLike = Partial<Pick<User, 'displayName' | 'givenName' | 'lastName' | 'userId'>> & {
  preferredFirstName?: string;
  name?: string;
};

function getTrimmedValue(value?: string): string {
  return value?.trim() || '';
}

export function getPreferredOrGivenFirstName(user?: UserLike): string {
  return getTrimmedValue(user?.preferredFirstName) || getTrimmedValue(user?.givenName) || getTrimmedValue(user?.name);
}

export function getPreferredDisplayName(user?: UserLike): string {
  const firstName = getPreferredOrGivenFirstName(user);
  const lastName = getTrimmedValue(user?.lastName);
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  return firstName || getTrimmedValue(user?.displayName) || getTrimmedValue(user?.userId);
}

export function formatUserName(value: string): string {
  if (!value) return '';
  if (value.includes(',')) {
    const [lastName, ...firstNameParts] = value.split(',');
    return `${firstNameParts.join(',').trim()} ${lastName.trim()}`.trim();
  }
  return value.trim().replace(/\s+/g, ' ');
}
